// import React, { useState } from 'react';
// import TronContext from './TronContext';

// const TronComponent = ({ children }) => {

//   const [tronWeb, setTronWeb] = useState(null);
//   const [account, setAccount] = useState(null);

//   const connectWallet = async () => {
//     if (window.tronLink) {
//       try {
//         await window.tronLink.request({ method: 'tron_requestAccounts' });
//         const tronWebInstance = window.tronWeb;
//         if (tronWebInstance) {
//           setTronWeb(tronWebInstance);
//           const defaultAddress = tronWebInstance.defaultAddress.base58;
//           if (defaultAddress) {
//             setAccount(defaultAddress);
//           } else {
//             console.error('Не удалось получить адрес по умолчанию');
//           }
//         } else {
//           console.error('TronWeb не инициализирован');
//         }
//       } catch (error) {
//         console.error('Ошибка при подключении к TronLink:', error);
//       }
//     } else {
//       alert('Пожалуйста, установите TronLink!');
//     }
//   };

//   const sendTransaction = async (to, amount, token) => {
//     if (!tronWeb || !to || !amount || !token) {
//       throw new Error("Missing required parameters");
//     }
//     try {
//       const contract = await tronWeb.contract().at(token.contractAddress);
//       const txHash = await contract.transfer(to, tronWeb.toSun(amount)).send();
//       return txHash;
//     } catch (error) {
//       console.error('Error sending transaction:', error);
//       throw error;
//     }
//   };

//   const disconnectWallet = () => {
//     setTronWeb(null);
//     setAccount(null);
//   };

//   // Передаем значения через контекст
//   const contextValue = {
//     tronWeb,
//     account,
//     connectWallet,
//     disconnectWallet,
//     sendTransaction,
//   };

//   return (
//     <TronContext.Provider value={contextValue}>
//       {children}
//     </TronContext.Provider>
//   );
// };

// export default TronComponent;








import React, { useState, useEffect, useContext } from 'react';
import TronContext from './TronContext';
import { cleanupTronStorage } from './utils/walletCleanup';
import { TronWeb } from 'tronweb';
import { WalletConnectWallet, WalletConnectChainID } from '@tronweb3/walletconnect-tron'
import ApiService from './Services/ApiService';
import PaymentDataContext from './PaymentDataContext.jsx';

// Lazy initialization
let walletConnectWallet = null;
let tronWebInstance = null;
const projectId = import.meta.env.VITE_PROJECT_ID;

const TronComponent = ({ children }) => {
  const { paymentData } = useContext(PaymentDataContext);
  const [tronWeb, setTronWeb] = useState(null);
  const [account, setAccount] = useState(null);
  const [wallet, setWallet] = useState(null);

  useEffect(() => {
    const tw = new TronWeb({ fullHost: 'https://api.trongrid.io' })
    setTronWeb(tw)
  }, [])

  const payError = (err_code, err_message) => {
    ApiService.payError({ Code: `${err_code}`, Message: err_message }).then(() => {
    }).catch((err) => console.log(err))
  }

  const connectWallet = async () => {
    try {

      if (wallet) {
        try { await wallet.disconnect() } catch { /* ignore */ }
      }

      const wc = new WalletConnectWallet({
        network: WalletConnectChainID.Mainnet,
        options: {
          projectId: projectId,
          metadata: {
            name: 'Cryllex',
            description: ' ',
            url: 'https://cryllex.com',
            icons: ['https://cryllex.com/favicon.ico']
          },
          disableProviderPing: true,
        },
        themeMode: 'dark',
      })

      const { address: addr } = await wc?.connect()

      setWallet(wc)
      setAccount(addr)
    } catch (err) {
      console.log(err);
    } finally {
    }
  }

  const toUsdtAmount = (value) => {
    return BigInt(Math.round(Number(value) * 1_000_000));
  }

  const sendTransaction = async (to, amount, token) => {
    if (!to || !amount || !token) {
      throw new Error("Missing required parameters");
    }
    if (!wallet || !account || !tronWeb) {
      setError('Wallet not connected')
      return
    }

    try {
      if (!tronWeb.isAddress(token.contractAddress)) {
        throw new Error(`Invalid USDT contract address: ${token.contractAddress}`)
      }
      if (!tronWeb.isAddress(to)) {
        throw new Error('Invalid recipient address. Please enter a valid TRON address.')
      }

      // ВАЖНО: address параметр передаём BASE58 (T...), НЕ hex
      const params = [
        { type: 'address', value: to },
        { type: 'uint256', value: toUsdtAmount(+amount).toString() },
      ]

      const { result, transaction } = await tronWeb.transactionBuilder.triggerSmartContract(
        token.contractAddress,
        'transfer(address,uint256)',
        { feeLimit: 200000000 },
        params,
        account
      )

      if (!result?.result || !transaction) {
        const msg = result?.message || 'Transaction trigger failed'
        throw new Error(msg)
      }

      let signed;
      try {
        signed = await wallet.signTransaction(transaction)
        if (!signed) {
          throw new Error('Transaction signing failed - no signed transaction returned')
        }
      } catch (signError) {
        console.log(signError);
        throw new Error(`Transaction signing failed: ${signError?.message || 'Unknown error'}.`)
      }

      // Send the signed transaction
      const sendResult = await tronWeb.trx.sendRawTransaction(signed);
      if (sendResult && sendResult.txid) {
        return sendResult.txid;
      } else {
        const errorMsg = sendResult?.message || 'Transaction send failed'
        throw new Error(errorMsg)
      }
    } catch (err) {
      console.log(err);
      if (paymentData.status === 0) {
        payError(err.name, err.message);
      }
    } finally { }

  };

  const disconnectWallet = async () => {
    try {
      await walletConnectWallet.disconnect();
      walletConnectWallet = null;
      setTronWeb(null);
      setAccount(null);
      cleanupTronStorage();
      console.log('✅ Wallet disconnected');
    } catch (error) {
      console.error('Error disconnecting wallet:', error);
      // Still reset state even if disconnect fails
      setTronWeb(null);
      setAccount(null);
    }
  };

  const contextValue = {
    tronWeb: tronWeb || tronWebInstance,
    account,
    connectWallet,
    disconnectWallet,
    sendTransaction,
  };

  return (
    <TronContext.Provider value={contextValue}>
      {children}
    </TronContext.Provider>
  );
};

export default TronComponent;


